<template>
    <CompassDialog
        :visible.sync="visible"
        :title="title"
        :primaryAction="primaryAction"
        :secondaryActions="secondaryActions"
        @closed="handleCancel"
    >
        <p class="typographies-paragraph-medium-regular">
            {{ message }}
        </p>
    </CompassDialog>
</template>

<script>
import { deleteEmailTemplate } from 'api/emailEngine/emailEngineService';

export default {
    props: {
        template: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            visible: true,
            title: this.$t.__('email.SettingsEmailsTemplatesDeleteModal.title'),
            message: this.$t.__('email.SettingsEmailsTemplatesDeleteModal.message'),
            isLoading: false,
        };
    },
    computed: {
        primaryAction() {
            return {
                label: this.$t.__('common.actions.delete'),
                type: 'primary-destructive',
                loading: this.isLoading,
                action: () => this.removeTemplate(),
            };
        },
        secondaryActions() {
            return [
                {
                    label: this.$t.__('common.actions.cancel'),
                    type: 'secondary',
                    action: () => this.handleCancel(),
                },
            ];
        },
    },
    methods: {
        removeTemplate() {
            this.isLoading = true;
            deleteEmailTemplate(this.template.id)
                .then(() => {
                    this.$pushToast({
                        type: 'success',
                        icon: true,
                        text: this.$t.__(
                            'email.SettingsEmailsTemplates.success_text_delete_template',
                        ),
                        close: true,
                    });
                    this.$emit('deleted', this.template.id);
                    this.$emit('close');
                })
                .catch(() => {
                    this.$pushToast({
                        type: 'error',
                        icon: true,
                        text: this.$t.__(
                            'email.SettingsEmailsTemplates.error_text_delete_template',
                        ),
                        close: true,
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        handleCancel() {
            this.$emit('close');
        },
    },
};
</script>
